export const profileData = [
    {
        id:'1',
      image: require("../../assets/setting/rolsAndpermissions/profile1.jpg"),
      name: "Eva Smith",
    },
    {
        id:'2',
      image: require("../../assets/setting/rolsAndpermissions/profile2.jpg"),
      name: "Martha Stewart",
    },
    {
        id:'3',
      image: require("../../assets/setting/rolsAndpermissions/profile1.jpg"),
      name: "Evelyn Josh",
    },
    {
        id:'4',
      image: require("../../assets/setting/rolsAndpermissions/profile2.jpg"),
      name: "Arthur Lewis",
    },
    {
        id:'5',
      image: require("../../assets/setting/rolsAndpermissions/profile1.jpg"),
      name: "Tom Edward",
    },
    {
        id:'7',
      image: require("../../assets/setting/rolsAndpermissions/profile2.jpg"),
      name: "Carisle Cullen",
    },
  ];